const bindSticky = () => {
	window.__bsAbRab007Ctl?.disconnect();
	window.__bsAbRab007Ctl = null;

	const sticky = document.querySelector('.bs-ab-rab-007-sticky-atc');
	const metaAtc = document.querySelector('.bs-product-informations__buy-buttons');
	const stickyButton = sticky?.querySelector('.bs-ab-rab-007-sticky-atc__button');
	const stickyButtonText = sticky?.querySelector('.bs-ab-rab-007-sticky-atc__button-text');
	const stickyButtonIcon = sticky?.querySelector('.bs-ab-rab-007-sticky-atc__button-icon');
	const stickyPrice = sticky?.querySelector('.bs-ab-rab-007-sticky-atc__price');
	const stickyUnitPrice = sticky?.querySelector('.bs-ab-rab-007-sticky-atc__unit-price');
	const stickyTitle = sticky?.querySelector('.bs-ab-rab-007-sticky-atc__title');
	const stickyImageWrapper = sticky?.querySelector('.bs-ab-rab-007-sticky-atc__image');
	const originalButton = document.querySelector(
		'.bs-product-informations__buy-buttons-form-buttons-button'
	);

	if (!sticky || !metaAtc || !stickyButton || !originalButton) return;

	const teardownFns = [];
	const addTeardown = (fn) => teardownFns.push(fn);

	const isOriginalLoading = () =>
		originalButton.classList.contains('loading') ||
		originalButton.getAttribute('aria-disabled') === 'true';

	const getCoverOffset = () => {
		const searchBottom =
			document.querySelector('.section-header .search-modal')?.getBoundingClientRect().bottom ?? 0;
		if (searchBottom > 0) return searchBottom;

		const headerBottom =
			document.querySelector('.section-header')?.getBoundingClientRect().bottom ?? 0;
		if (headerBottom > 0) return headerBottom;

		const fromVar = parseFloat(
			getComputedStyle(document.documentElement).getPropertyValue('--header-height')
		);
		if (fromVar > 0) return fromVar;
		return window.matchMedia('(max-width: 767px)').matches ? 121 : 0;
	};

	const updateVisibility = () => {
		const rect = metaAtc.getBoundingClientRect();
		const scrolledPast = rect.bottom < getCoverOffset();
		sticky.classList.toggle('is-visible', scrolledPast);
		sticky.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
	};

	const getSourceImage = () => {
		const selectors = [
			'media-gallery img',
			'.bs-product-main-media-slider__main-item.swiper-slide-active img',
			'.bs-product-main-media-slider__main-item img',
			'.bs-product-main-media img',
		];

		for (const selector of selectors) {
			const img = document.querySelector(selector);
			if (img?.src) return img;
		}

		return null;
	};

	const syncDetails = () => {
		const livePrice = document.querySelector('.bs-product-informations__price .price');
		if (livePrice && stickyPrice) {
			stickyPrice.replaceChildren(livePrice.cloneNode(true));
		}

		const liveUnitPrice = document.querySelector(
			'.bs-product-informations__price-container-unit-price'
		);
		if (liveUnitPrice && stickyUnitPrice) {
			stickyUnitPrice.replaceChildren(...liveUnitPrice.cloneNode(true).childNodes);
			stickyUnitPrice.classList.toggle('hidden', liveUnitPrice.classList.contains('hidden'));
		}

		const liveTitle = document.querySelector(
			'.bs-product-informations__title h1, .product__title h1, h1.title'
		);
		if (liveTitle && stickyTitle) {
			stickyTitle.textContent = liveTitle.textContent.trim();
		}

		if (!stickyImageWrapper) return;

		const sourceImg = getSourceImage();
		if (!sourceImg) return;

		let stickyImg = stickyImageWrapper.querySelector('img');
		if (!stickyImg) {
			stickyImg = document.createElement('img');
			stickyImageWrapper.appendChild(stickyImg);
		}

		stickyImg.src = sourceImg.currentSrc || sourceImg.src;

		if (sourceImg.srcset) {
			stickyImg.srcset = sourceImg.srcset;
		} else {
			stickyImg.removeAttribute('srcset');
		}

		if (sourceImg.sizes) {
			stickyImg.sizes = sourceImg.sizes;
		} else {
			stickyImg.removeAttribute('sizes');
		}

		if (sourceImg.alt) {
			stickyImg.alt = sourceImg.alt;
		}
	};

	const syncButtonState = () => {
		stickyButton.disabled = originalButton.disabled;

		if (isOriginalLoading()) return;

		const originalText = originalButton.querySelector(
			'.bs-product-informations__buy-buttons-form-buttons-button-text'
		);
		if (originalText && stickyButtonText) {
			stickyButtonText.textContent = originalText.textContent.trim();
		}

		if (stickyButtonIcon) {
			const hasBuyIcon = [...originalButton.querySelectorAll('svg')].some(
				(svg) => !svg.closest('.loading__spinner')
			);
			stickyButtonIcon.hidden = stickyButton.disabled || !hasBuyIcon;
		}
	};

	const intersectionObserver = new IntersectionObserver(
		() => {
			updateVisibility();
		},
		{ threshold: 0 }
	);
	intersectionObserver.observe(metaAtc);
	addTeardown(() => intersectionObserver.disconnect());

	let resizeTimer;
	const onResize = () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(updateVisibility, 100);
	};
	window.addEventListener('resize', onResize);
	addTeardown(() => {
		clearTimeout(resizeTimer);
		window.removeEventListener('resize', onResize);
	});

	const onScroll = () => updateVisibility();
	window.addEventListener('scroll', onScroll, { passive: true });
	addTeardown(() => window.removeEventListener('scroll', onScroll));

	const onStickyClick = () => {
		if (stickyButton.disabled || isOriginalLoading()) return;
		originalButton.click();
	};
	stickyButton.addEventListener('click', onStickyClick);
	addTeardown(() => stickyButton.removeEventListener('click', onStickyClick));

	const buttonMutationObserver = new MutationObserver(() => {
		syncButtonState();
		syncDetails();
	});
	buttonMutationObserver.observe(originalButton, {
		attributes: true,
		attributeFilter: ['disabled', 'aria-disabled', 'class'],
		childList: true,
		subtree: true,
	});
	addTeardown(() => buttonMutationObserver.disconnect());

	const priceContainer =
		document.querySelector('.bs-product-informations__price') ||
		document.querySelector('[id^="price-"]');

	if (priceContainer) {
		const priceMutationObserver = new MutationObserver(syncDetails);
		priceMutationObserver.observe(priceContainer, {
			childList: true,
			subtree: true,
			characterData: true,
		});
		addTeardown(() => priceMutationObserver.disconnect());
	}

	const syncTimeout0 = setTimeout(syncDetails, 0);
	const syncTimeout100 = setTimeout(syncDetails, 100);
	addTeardown(() => {
		clearTimeout(syncTimeout0);
		clearTimeout(syncTimeout100);
	});

	syncButtonState();
	syncDetails();
	updateVisibility();

	window.__bsAbRab007Ctl = {
		disconnect() {
			teardownFns.forEach((fn) => fn());
		},
	};
};

window.activateAbRAB007 = () => {
	document.body.setAttribute('data-ab-rab-007', '');

	if (!window.__bsAbRab007) {
		window.__bsAbRab007 = true;
		document.addEventListener('product-info:loaded', bindSticky);
	}

	bindSticky();
};

// document.addEventListener('DOMContentLoaded', () => {
// 	window.activateAbRAB007();
// });
